import React from "react";
import { get, noop } from "lodash";
import Icon from "@fdr/static-ui/Icons";
import allIcons from "@fdr/static-ui/Icons/icons";
import buildColor from "@fdr/static-ui/ColorPalette";
// @ts-ignore
import Button from "../../_atoms/Button";
import {
  ButtonScrollbarWrapper,
  ViewAllButton,
  ButtonsContainer
} from "./styled-components";
import { ButtonScrollbarProps } from "./types";

function ButtonScrollbar<T>({
  qaLabel = "button-scrollbar",
  buttons,
  keyExtractor,
  buttonType,
  buttonSize = "medium",
  backgroundColor,
  iconColor,
  onViewAllClick,
  onItemClick = noop
}: React.PropsWithChildren<ButtonScrollbarProps<T>>) {
  return buttons.length > 0 ? (
    <ButtonScrollbarWrapper
      data-qa-label={qaLabel}
      backgroundColor={backgroundColor}
    >
      <ButtonsContainer>
        {buttons.map((button, index) => {
          const key = keyExtractor(button) || index;
          return (
            <Button
              qaLabel={`button-${key}`}
              key={key}
              type={buttonType}
              size={buttonSize}
              onClick={() => {
                onItemClick(button);
              }}
            >
              {button?.icon && get(allIcons, button.icon) && (
                <Icon
                  icon={allIcons[button.icon]}
                  color={
                    iconColor
                      ? buildColor(iconColor.color, iconColor.variation)
                      : buildColor("grey", "L3")
                  }
                />
              )}
              {button.title}
            </Button>
          );
        })}
      </ButtonsContainer>
      {onViewAllClick && (
        <ViewAllButton
          onClick={onViewAllClick}
          role="button"
          data-qa-label="button-scrollbar-view-all"
        >
          View All
          <Icon
            icon={allIcons.arrowRight}
            color={buildColor("grey", "L3")}
            size={17}
            qaLabel={`${qaLabel}-icon`}
          />
        </ViewAllButton>
      )}
    </ButtonScrollbarWrapper>
  ) : null;
}

export default ButtonScrollbar;
